
// src/features/auth/auth.slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GroupDescriptor } from "@progress/kendo-data-query";
import { IColumn } from '../../types/User/IGridState';


export interface RevState {
    tenantUid?: string;
}

const initialState: RevState = {

};

const revSlice = createSlice({
    name: 'rev',
    initialState,
    reducers: {
        setTenantId(state, action: PayloadAction<string>) {
            state.tenantUid = action.payload;
        },
    },
});

export const { setTenantId } = revSlice.actions;
export default revSlice.reducer;